module.exports = __webpack_public_path__ + "img/pt-BR.9cbe8ccd.png";